module.exports = __webpack_public_path__ + "img/well_fudao_bg.f5eb34dc.png";